import axios from "../axios-auth";
import orginal_axios from "axios";

export const wayService = {
  getWaysByStatus,
  getWayList,
  saveWay,
  getWayDetail,
  saveWayExcel,
  getWayExcelTemplate,
  getWayExcelExport
};

function getWayList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  return axios.get("/auth/ways", { params });
}

function saveWay(way) {
  if (!way.id) {
    // new way
    return axios.post("/auth/way", way);
  } else {
    // edit
    return axios.put("/auth/way", way);
  }
}

function getWayDetail(id) {
  return axios.get("/auth/way/" + id);
}

function getWaysByStatus(status) {
  return axios.get("/auth/ways-by-status/" + status);
}

function saveWayExcel(file) {
  return axios.post('/auth/way-excel',
      file,
      {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      }
  )
}

function getWayExcelTemplate() {
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/way-excel-template",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function getWayExcelExport(searchParams){
  let params={};

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/way-excel-export",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}